import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Icon, { AppstoreOutlined, MenuOutlined } from '@ant-design/icons';
import Slide from '@material-ui/core/Slide';
import PropType from 'prop-types'
import {toDateTime} from '../../../shared/functions/toDateTime';
import PurchaseCartDetailList from './dataGrid/PurchaseCartDetailList';
import {groupBy} from 'lodash'
import {useDispatch} from "react-redux";
import {purchaseCartList} from "../../../redux/slices/purchaseCartList";
import {nanoid} from "@reduxjs/toolkit";



const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
        color: '#fff'
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function PurchaseCartDetails({frontCart, handleClose}) {
    const classes = useStyles(); 

    const [list, setList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [v2ApiHasBeenCalled, setv2ApiHasBeenCalled] = useState(false)
    const dispatch = useDispatch()
    const [listcard,setListCard]= useState('card');
    const handleTableShowing = (etat) =>{
       if(etat=='card'){
        setListCard('card');
        }
        else{
        setListCard('list');
         }
}

     
    if (!v2ApiHasBeenCalled) {
        setIsLoading(true)

        dispatch(purchaseCartList({
            docId: frontCart.id, onResolve: (data) => { 
                setList(data)
                setIsLoading(false) 
            }
        }))

        setv2ApiHasBeenCalled(true)
    }

 
 


    return (
        <div>
            <Dialog fullScreen open onClose={handleClose} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                     

                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon/>
                        </IconButton>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            retour
                        </Button>
                        {/* <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close" style={{marginLeft: "25px"}}>
                            <MenuOutlined />
                        </IconButton>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            SHOW LIST
                        </Button> */}
                                {/* {listcard=='card'?
                                    <Button onClick={()=>handleTableShowing('list')}>
                                    <MenuOutlined />
                                     SHOW LIST | TOTAL D'ITEMS: {Data.length}
                                    </Button>:
                                     <Button onClick={()=>handleTableShowing('card')}>
                                     <AppstoreOutlined />
                                     SHOW CARD | TOTAL D'ITEMS: {Data.length}
                                     </Button>}  */}
                        
                    </Toolbar>
                </AppBar>
                <PurchaseCartDetailList CartI={frontCart.id}  isLoading={isLoading}/>
            </Dialog>
            
        </div>
    );
}


PurchaseCartDetails.propTypes = {
    handleClose: PropType.func.isRequired,
    frontCart: PropType.object.isRequired,
}
